var map = {
	"./aa-KEC StrategicPlan 2015-20.pdf": 72166,
	"./ab-KEC StrategicPlan 2020-25.pdf": 57660,
	"./ac-KEC StrategicPlan 2025-30.pdf": 98612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39552;